import { useTheme } from "@emotion/react";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import {
  Avatar,
  Box,
  CssBaseline,
  ListItemIcon,
  Menu,
  MenuItem,
  Stack,
  Toolbar} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import userProf from "../assets/images/userProf.png";
import { getCompanyDetails } from "../pages/company/action";
import { useGetUserDetailsQuery } from "../redux/api";
import { setSidebar } from "../redux/reducer";
import { getCompanyid, getUserType, isMobile, setCompanyName, setCompanyid } from "../utils/common";
import { COMPANY } from "../utils/constant";
import { ROUTES } from "../utils/routes";
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import useDeviceType from '../hooks/useDeviceType'
import { persistor } from "../redux/store";
import user from '../assets/images/icons/user.svg'
import viewSubscription from '../assets/images/icons/viewSubscription.svg'
import manageUser from '../assets/images/icons/manageUser.svg'
import logoutIcon from '../assets/images/icons/logouticon.svg'

const Header = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const states = useSelector((state) => state.app);
  const deviceType = useDeviceType();
  const { userInfo } = useSelector((state) => state.commonSlice);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const sidebarRef = useRef(null);
  let userData = localStorage.getItem('user')
  if (userData) userData = JSON.parse(userData)

  const { data, isSuccess } = useGetUserDetailsQuery(userData?.id);

  const [adminData, setadminData] = React.useState({
    name: "",
    image: "",
    type: ""
  });


  useEffect(() => {
    if (data?.status === "SUCCESS") {

      setadminData({
        name: data.result?.adminName ? data.result?.adminName : data.result?.companyName,
        image: data.result?.logo ? data.result?.logo : userProf,
        type: data.result?.userType ? data.result?.userType : '',

      });
      setCompanyName(data.result?.companyName);
      setCompanyid(data?.result?.companyId || data.result?.id)
    }
  }, [isSuccess]);


  const handleToggleSidebar = (e) => {
    e.preventDefault();
    dispatch(setSidebar({fromSidebarButton:!states.fromSidebarButton}));
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target) && states.sidebar) {
      dispatch(setSidebar());
    }
  };

  useEffect(() => {

    if (isMobile()) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, []);


  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          flexGrow: 1,overflow:'hidden',
          marginLeft: states.sidebarWidth,
          width:'100%',
          transition: `"all ${theme.transitions.duration.short}ms ${theme.transitions.easing.easeInOut}"`,
        }}
      >
        <div className={`${(location.pathname==='/discover-influencers/listing') ? "discovery-influencer-header" : "mainheader"} ${!states.sidebar ? 'activeHeader' : ''}`} color={"background"} >
          <Toolbar>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              width={"100%"}
            >
              <span ref={sidebarRef} >
                {
                  deviceType === 'desktop' ? (states.sidebarWidth === '80px' ? <MenuRoundedIcon className="menuIcon cursorPointer" onClick={handleToggleSidebar} />
                    : (states.fromSidebarButton && <CloseRoundedIcon className="menuIcon cursorPointer" onClick={handleToggleSidebar} />)) : ( <MenuRoundedIcon className="menuIcon cursorPointer" onClick={handleToggleSidebar} />)
                }
                </span>
              {<Stack
                direction={"row"}
                alignItems={"center"}
                gap={3}
                sx={{ cursor: "pointer", }}
                onClick={handleClick}              >
                <Stack direction={"row"} alignItems={"center"} gap={1}>
                  <div className="avtarImg">
                    <Avatar src={userInfo?.photoUrl ? userInfo?.photoUrl : "/"} alt={getUserType() === COMPANY ? userInfo?.companyName?.toUpperCase() || userInfo?.contactPersonName : userInfo?.adminName?.toUpperCase()} />
                  </div>
                  <Stack className="userNme">
                    <h5>{getUserType() === COMPANY ? userInfo?.companyName || userInfo?.contactPersonName : userInfo?.adminName}</h5>
                    <label>{adminData?.type}</label>
                  </Stack>
                  <ExpandMoreOutlinedIcon sx={{ color: '#000' }} disableRipple />
                </Stack>
              </Stack>}
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={Boolean(anchorEl)}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
                getContentAnchorEl={null}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'hidden',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 5.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      // ml: -0.5,
                      // mr: 1,
                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      zIndex: 0,
                    },
                    '& .MuiMenuItem-root': {
                      padding: '12px 6px 8px 6px', borderBottom: '1px solid #EEEEEE', paddingLeft: '16px',background:'white',
                    },
                    "& ul": {
                      display: 'flex',
                      flexDirection: 'column', padding: '0', gap: '0px',
                    },
                    width: '200px',
                    height: 'auto',
                    maxHeight: '175px',
                    fontSize: '14px',
                    fontWeight: '400',
                    color: '#565656',
                    borderRadius: '12px',
                    border: '1px solid #EEEEEE',
                    boxShadow: '0px 4px 12px 0px #0000001F',
                  },
                }}
                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                {getUserType() === COMPANY && <>
                  <MenuItem onClick={() => {
                    handleClose();
                    dispatch(getCompanyDetails(getCompanyid(), navigate))
                  }}>
                    <ListItemIcon>
                      <img src={user} width={20} height={20} alt="user" />
                    </ListItemIcon>
                    Profile<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleClose();
                    navigate(ROUTES.SUBSCRIPTION_FOR_COMPANY)
                  }}>
                    <ListItemIcon>
                      <img src={viewSubscription} width={20} height={20} alt="user" />
                    </ListItemIcon> View Subscription<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                  <MenuItem onClick={() => {
                    handleClose();
                    navigate(ROUTES.COMPANY_USERS)

                  }}>
                    <ListItemIcon>
                      <img src={manageUser} width={20} height={20} alt="user" />
                    </ListItemIcon>Manage Users<ListItemIcon sx={{ marginLeft: "auto", }}>
                    </ListItemIcon>
                  </MenuItem>
                </>}

                <MenuItem onClick={() => {
                  handleClose();
                  dispatch({ type: 'USER_LOGOUT' });
                  persistor.purge();
                  localStorage.clear();
                  navigate(ROUTES.LOGIN)
                }}>
                  <ListItemIcon>
                    <img src={logoutIcon} width={20} height={20} alt="user" />
                  </ListItemIcon>
                  Logout
                  <ListItemIcon sx={{ marginLeft: "auto", }}>
                  </ListItemIcon>
                </MenuItem>
              </Menu>
            </Stack>
          </Toolbar>
        </div>
      </Box>
    </>
  );
};

export default Header;
